import { Alert, ProgressBar, Button } from "react-bootstrap"
import React, { Component } from "react"

export default function RefreshStatus({
	progress,
	count,
	errors,
	done,
	updatedAt,
	onRefresh,
}) {
	const hasErrors = errors !== undefined && Object.keys(errors).length !== 0
	if (hasErrors) {
		let isFirstElement = true
		const elements = []
		for (const id of Object.keys(errors)) {
			elements.push(
				<Alert key={id} bsStyle="warning">
					{errors[id]}{" "}
					{isFirstElement ? (
						<RefreshButton content="Retry" onRefresh={onRefresh} />
					) : null}
				</Alert>
			)
			isFirstElement = false
		}
		return <div>{elements}</div>
	}

	if (count === 0) {
		count = 1
	}
	const finished = progress !== undefined ? Object.keys(progress).length : 0
	let now = finished / count
	if (now < 0.1) {
		now = 0.1
	}
	if (done) {
		const updatedAtString = updatedAt.toLocaleDateString("en-US", {
			weekday: "long",
			month: "long",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			second: "numeric",
		})
		return (
			<Alert bsStyle="info">
				Portfolio updated at <b>{updatedAtString}</b>.{" "}
				<RefreshButton onRefresh={onRefresh} />
			</Alert>
		)
	}
	return <ProgressBar active now={now} max={1} />
}

class RefreshButton extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isRefreshing: false,
		}
	}

	render() {
		const { content = "Refresh" } = this.props
		const { isRefreshing } = this.state
		return (
			<Button
				bsSize="xsmall"
				onClick={this.handleClick}
				disabled={isRefreshing}
			>
				{content}
			</Button>
		)
	}

	handleClick = () => {
		this.setState({
			isRefreshing: true,
		})
		this.props.onRefresh()
	}
}



// WEBPACK FOOTER //
// ./src/RefreshStatus.js